import angular from 'angular';

export default angular
  .module('csm.ui.valueDisplay', [])
  /*******************************************************************************
   * valueDisplay */
  /**
   * @ngdoc     directive
   * @name      valueDisplay
   * @memberof  csm.ui.valueDisplay
   *
   * This utilizes the bootstrap input group styling to render a label and value
   * in a bordered container. The label and default value field can be styled using
   * the valueLabel and valueField classes respectively.
   *
   * @attr {string}     label  Label text to show
   * @attr {expression} value  Optional value expression to use to populate display
   *
   * Note: This directive allows for custom value rendering through transclusion
   *       where the content is added after the label. The content should use the
   *       form-control class for proper styling.
   *******************************************************************************/
  .directive('valueDisplay', function ($compile) {
    return {
      restrict: 'E',
      transclude: true,
      template:
        '<span style="font-weight:bold" class="input-group-addon valueLabel" ng-bind="label">',
      scope: { label: '@', value: '&' },
      link: function ($scope, element, attr, ctrl, transclude) {
        element.addClass('input-group');

        transclude(function (clone, scope) {
          var useTransclude = clone.length > 0;

          /*-----------------------------------------*/
          /* Add the transcluded content if provided */
          /*-----------------------------------------*/
          if (useTransclude) element.append(clone);
          /*------------------------------------------*/
          /* Otherwise no transclusion content, add   */
          /* a span that renders the value expression */
          /*------------------------------------------*/ else
            element.append(
              $compile(
                angular.element(
                  '<span class="form-control valueField" ng-bind="value()"></span>'
                )
              )($scope)
            );
        });
      }
    };
  }).name;
